import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { getOverride, getSlug, loginPath, setSlug } from "@/lib/tenant";
import { isEmbed } from "@/lib/embed";

const AuthContext = createContext(null);
const me = () => api.get("/auth/me").then((r) => {
  const u = r.data;
  if (!isEmbed() && !getOverride() && u?.tenant?.slug !== undefined) {
    if (getSlug() !== u.tenant.slug) localStorage.removeItem("crm-filters");
    setSlug(u.tenant.id === "default" ? "" : u.tenant.slug);
  }
  return u;
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (window.location.pathname.startsWith("/embed")) return;
    me().then(setUser).catch(() => api.post("/auth/refresh").then(me).then(setUser).catch(() => setUser(false)));
  }, []);

  const login = async (email, password, tenant = "", extra = {}) => {
    localStorage.removeItem("crm_tenant_override");
    await api.post("/auth/login", { email, password, tenant, ...extra });
    setUser(await me());
  };
  const logout = async () => {
    const dest = loginPath();
    await api.post("/auth/logout");
    localStorage.removeItem("crm_tenant_override");
    window.location.href = dest;
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export const NAV_SECTION = {
  dashboard: "dashboard", clienti: "customers", "kpi-carte": "cards", segmenti: "segments", fedelta: "loyalty", transazioni: "transactions",
  "punti-vendita": "stores", "carta-fedelta": "fidelity", cluster: "clusters", comunicazioni: "campaigns", paniere: "basket", promozioni: "promo",
  "analisi-ia": "ai", report: "reports", "volantini-promo": "flyers", premi: "gifts", impostazioni: "settings", assistenza: "tickets", manuale: "manual",
};

export const usePerm = (section) => {
  const { user } = useAuth();
  return user?.permissions?.[section] || "none";
};

export const useFeature = (key) => {
  const { user } = useAuth();
  return user?.features?.[key] !== false;
};
